import { Link } from "react-router-dom";

import { useEffect } from "react";
import { Helmet } from "react-helmet";


function Aboutus() {



	useEffect(() => {
		window.scrollTo(0, 0);
	}, []);

	return (
		<>

			<Helmet>
				<title>About Our Company | Taskflier | A Trusted Platform for Outsourcing Project </title>
			</Helmet>


		
				<div class="block-style-thirtySix bg-white lg-container pt-110 " id="feature">
					<div class="container">
						<div class="row">
							<div class="col-xl-6 col-lg-6  aos-init aos-animate" data-aos="fade-left">
								<div class="pl-lg-5">
									<div class="title-style-fourteen">
										<h6><span class="upper-title custom-name">About us</span></h6>
										<h1>About TaskFlier</h1>
									</div>
									<div class="tag-line">TaskFlier emerges as the premier management system developed by MNB Soft Solutions. Thanks to the folks at TaskFlier, the operational concerns that plague today’s businesses are well understood and thus we embark on a trip to ease processes, enhance productivity, and improve inter-relationships, among many other things.</div>


									<Link class="theme-btn-2 mt-10 md-mt-30" to="/demo/request">Request Demo <i class="bi bi-arrow-right pl-2"></i></Link>
								</div>
							</div>
							<div class="col-xl-6 col-lg-6 text-center text-lg-left  aos-init aos-animate" data-aos="fade-right">
								<div class="illustration-holder d-inline-block md-mt-60">
									<img src="/main/images/project.jpg" alt="" />

								</div>
							</div>
						</div>
					</div>
				</div>

				<div class="fancy-feature-sixteen md-mt-100 bg-white" id="feature">
					<div class="container">


						<div class="block-style-eighteen pt-120 pb-80 md-mt-80">
							<div class="row align-items-center">
								<div class="col-lg-5 order-lg-last aos-init" data-aos="fade-left" data-aos-duration="1200">
									<div class="text-wrapper">
										<h6>Scanning &amp; Doc</h6>
										<h3 class="title">Our Mission</h3>
										<p>Every organization needs powerful solutions that demonstrate our mission – eradicate the customary barriers in office management. In every organization, the management of tasks and resources as well as communication is a core operating strategy. As integrated TMS systems are what TaskFlier has built it was built with the vision that many employees no longer have to be made to work harder to get their teams to achieve better.</p>

									</div>
								</div>
								<div class="col-lg-7 order-lg-first aos-init" data-aos="fade-right" data-aos-duration="1200">
									<div class="screen-holder-two">
										<img src="images/mission.jpg" alt="" />

									</div>
								</div>
							</div>
						</div>


					</div>
				</div>
				<div class="fancy-feature-thirtyOne pt-120 pb-160 md-pt-80 md-pb-100 bg-blue">
					<div class="container">
						<div class="row">
							<div class="col-lg-8 m-auto">
								<div class="title-style-four text-center pb-50 md-pb-20">
									<h2>Our Commitments</h2>
									<p class="sub-text pt-20">At TaskFlier, we are committed to providing you with excellent office management experience. We prioritize:
									</p>
								</div>
							</div>
						</div>
						<div class="row">
							<div class="col-md-6 aos-init" data-aos="fade-up">
								<div class="block-style-thirtyTwo d-flex">
									<div class="icon d-flex align-items-center justify-content-center pink"><img src="/images/icon/178.svg" alt="" /></div>
									<div class="text">
										<h4>User-Centered Design</h4>
										<p>We are dedicated to creating user-friendly interfaces that make your workflow easier. Your feedback drives our improvements. To ensure that TaskFlier meets your changing needs.</p>

									</div>
								</div>
							</div>
							<div class="col-md-6 aos-init" data-aos="fade-up" data-aos-delay="100">
								<div class="block-style-thirtyTwo d-flex">
									<div class="icon d-flex align-items-center justify-content-center greens" ><img src="/images/icon/179.svg" alt="" /></div>
									<div class="text">
										<h4>Reliability and Performance</h4>
										<p>Our applications are built on a robust framework. This guarantees consistent performance and uptime. We understand the importance of having reliable tools at your fingertips.</p>

									</div>
								</div>
							</div>
							<div class="col-md-6 aos-init" data-aos="fade-up">
								<div class="block-style-thirtyTwo d-flex">
									<div class="icon d-flex align-items-center justify-content-center blues" ><img src="/images/icon/180.svg" alt="" /></div>
									<div class="text">
										<h4>Continuous Innovation</h4>
										<p>We strive to stay ahead of the curve. Our team is researching and implementing new features. Continuously increasing efficiency and improving user experience
										</p>

									</div>
								</div>
							</div>
							<div class="col-md-6 aos-init" data-aos="fade-up" data-aos-delay="100">
								<div class="block-style-thirtyTwo d-flex">
									<div class="icon d-flex align-items-center justify-content-center purples" ><img src="/images/icon/181.svg" alt="" /></div>
									<div class="text">
										<h4>Excellent support</h4>
										<p>Customer satisfaction is our top priority. Our support team is always ready to assist you by providing timely and effective solutions to any challenges you may face.</p>

									</div>
								</div>
							</div>
						</div>
					</div>
				</div>

				<div class="block-style-thirtySix bg-white lg-container pt-110  pb-80" id="feature">
					<div class="container">
						<div class="row">

							<div class="col-xl-6 col-lg-5 text-center text-lg-left  aos-init aos-animate" data-aos="fade-right">
								<div class="illustration-holder d-inline-block md-mt-60">
									<img src="/images/secure.jpg" alt="" class="w-100" />

								</div>
							</div>


							<div class="col-xl-6 col-lg-7  aos-init aos-animate" data-aos="fade-left">
								<div class="pl-lg-5">
									<div class="title-style-fourteen">

										<h2>Security and Privacy</h2>
									</div>
									<div class="tag-line">We take the security of your data seriously. TaskFlier has been designed with strong security measures to protect your data and preserve your privacy.</div>

									<div class="tag-line">With TaskFlier, you don't just accept the tool. You are gaining a partner dedicated to your success. Thank you for choosing us to improve your office management processes</div>
								</div>
							</div>

						</div>
					</div>
				</div>

				<div class="fancy-feature-eight pt-0 pb-110 md-mt-80 bg-white">
					<div class="container">
						<div class="row">
							<div class="col-xl-12 m-auto">
								<div class="title-style-four text-center mb-60 md-mb-30">
									<h2>What We Offer
									</h2>
								</div>
							</div>
						</div>
						<div class="row">
							<div class="col-xl-11 m-auto">
								<div class="row">
									<div class="col-md-6 aos-init aos-animate" data-aos="fade-up" data-aos-duration="1200">
										<div class="block-style-ten">
											<div class="icon"><img src="images/icon/55.svg" alt="" /></div>
											<h6 class="title">Organized Workflows</h6>
											<p className="why">TaskFlier allows you to quickly allocate, track, and manage tasks throughout your organization. Interaction among the members of the team is so smooth that everyone is kept in the loop.</p>

										</div>
									</div>
									<div class="col-md-6 aos-init aos-animate" data-aos="fade-up" data-aos-duration="1200" data-aos-delay="100">
										<div class="block-style-ten">
											<div class="icon"><img src="images/icon/57.svg" alt="" /></div>
											<h6 class="title">Improved Communication</h6>
											<p className="why">Every team knows how important it is to communicate; for this reason, TaskFlier came up with features that allow for chat and file sharing so that it is possible to work on a project regardless of the location of the team members.</p>

										</div>
									</div>

									<div class="col-md-6 aos-init aos-animate" data-aos="fade-up" data-aos-duration="1200">
										<div class="block-style-ten">
											<div class="icon"><img src="images/icon/55.svg" alt="" /></div>
											<h6 class="title">Managing Resources</h6>
											<p className="why">Productivity can only be maximized when the resources are well managed. With TaskFlier, you will be able to manage resources, check out availability, and ensure that your team is well-equipped with everything they need to excel.</p>

										</div>
									</div>
									<div class="col-md-6 aos-init aos-animate" data-aos="fade-up" data-aos-duration="1200" data-aos-delay="100">
										<div class="block-style-ten">
											<div class="icon"><img src="images/icon/57.svg" alt="" /></div>
											<h6 class="title">Pre-Packed Tools</h6>
											<p className="why">Every organization is different and so are their demands. To meet the needs of all users of TaskFlier, the application provides configurable options for users to change how they want the application to work.</p>

										</div>
									</div>
								</div>
							</div>
						</div>
					</div>
				</div>

				<div class="fancy-feature-twentySix lg-container bg-white pt-0 md-pt-100">
					<div class="container">
						<div class="row">
							<div class="col-md-6 aos-init aos-animate" data-aos="fade-right">
								<div class="block-style-twentySix text-center mb-40" style={{ background: "#E8FBFF" }}>
									<h6 >Provide Great Customer Service</h6>
									<p>Assist our users with timely and efficient support to ensure that they have the necessary resources so that TaskFlier can be of great benefit.</p>

									<img src="images/shape/222.jpg" alt="" class="shapes shape-one" />
									<img src="images/shape/223.jpg" alt="" class="shapes shape-two" />
								</div>
							</div>
							<div class="col-md-6 aos-init aos-animate" data-aos="fade-left">
								<div class="block-style-twentySix text-center mb-40" style={{ background: "#FFEFE7" }}>
									<h6 >Drive Continuous Innovation</h6>
									<p>Keep TaskFlier in line with the latest industry trends and technological advancements, introducing new features and improvements to support modern workplaces.</p>

									<img src="images/shape/224.jpg" alt="" class="shapes shape-one" />
									<img src="images/shape/225.jpg" alt="" class="shapes shape-two" />
								</div>
							</div>
						</div>
					</div>
				</div>
				<div class="fancy-feature-eighteen md-mt-80" id="feature">



					<div class="tab-content aos-init" data-aos="fade-up" data-aos-duration="1200" data-aos-delay="150">
						<div class="tab-pane active" id="ft1">
							<div class="row no-gutters align-items-center">
								<div class="col-md-6">
									<div class="img-holder">
										<img src="/images/team.png" alt="" />
										{/* <div class="ripple-box d-flex align-items-center justify-content-center">
				  						<p>Track Human faces</p>
				  					</div> */}
									</div>
								</div>
								<div class="col-md-6">
									<div class="text-wrapper">

										<h4>JOIN US</h4>

										<p className="join">Encounter the future of office management with TaskFlier. whether you mean inauguration or amp great initiative our diligence is organized to accommodate your increase and service you reach your goals

											Explore Taskflier now and translate the room where your squad collaborates and manages tasks
											for further information look clear to hand away to America or agenda amp show. Let's work together to Make a more productive and connected workplace!
										</p>
									</div>
								</div>
							</div>
						</div>

					</div>
					<img src="/images/shape/175.svg" alt="" class="shapes shape-right" />
					<img src="/images/shape/176.svg" alt="" class="shapes shape-left" />
				</div>
				
		</>
	);
}

export default Aboutus;